// src/pages/Contact.js
import React, { useState } from "react";

const Contact = () => {
  const [form,    setForm]    = useState({ name: "", email: "", subject: "", message: "" });
  const [sent,    setSent]    = useState(false);
  const [loading, setLoading] = useState(false);

  const change = (e) => setForm(p => ({ ...p, [e.target.name]: e.target.value }));

  const handleSubmit = (e) => {
    e.preventDefault();
    setLoading(true);
    // Simulate send — replace with your email service (EmailJS, Formspree, etc.)
    setTimeout(() => {
      setSent(true);
      setLoading(false);
    }, 1200);
  };

  if (sent) {
    return (
      <div className="page page--center">
        <div className="state-box">
          <span className="state-box__icon">✅</span>
          <h2 className="state-box__title">Message Sent!</h2>
          <p className="state-box__sub">
            Thank you for reaching out. We'll get back to you within 24–48 hours.
          </p>
        </div>
      </div>
    );
  }

  return (
    <div className="page">
      <div className="container static-page">
        <div className="static-hero">
          <span className="hero__badge">Get In Touch</span>
          <h1 className="static-hero__title">Contact <span className="hero__accent">Us</span></h1>
          <p className="static-hero__sub">Have a question or feedback? We'd love to hear from you.</p>
        </div>

        <div className="contact-grid">
          {/* Info cards */}
          <div className="contact-info">
            <div className="contact-info-card">
              <span className="contact-info-icon">📧</span>
              <div>
                <p className="contact-info-label">Email Us</p>
                <a href="mailto: workysales@gmail.com" className="contact-info-value">
                  support@halro.online
                </a>
              </div>
            </div>
            <div className="contact-info-card">
              <span className="contact-info-icon">⏰</span>
              <div>
                <p className="contact-info-label">Response Time</p>
                <p className="contact-info-value">Within 24–48 hours</p>
              </div>
            </div>
            <div className="contact-info-card">
              <span className="contact-info-icon">🌐</span>
              <div>
                <p className="contact-info-label">Website</p>
                <p className="contact-info-value">halro.online</p>
              </div>
            </div>
            <div className="contact-info-card">
              <span className="contact-info-icon">🐛</span>
              <div>
                <p className="contact-info-label">Report a Bug</p>
                <p className="contact-info-value">Use the form →</p>
              </div>
            </div>
          </div>

          {/* Form */}
          <form className="contact-form" onSubmit={handleSubmit}>
            <div className="contact-form-row">
              <div className="field">
                <label className="field__label" htmlFor="c-name">Your Name</label>
                <input id="c-name" name="name" type="text" className="field__input"
                  placeholder="Jane Smith" value={form.name} onChange={change} required disabled={loading} />
              </div>
              <div className="field">
                <label className="field__label" htmlFor="c-email">Email Address</label>
                <input id="c-email" name="email" type="email" className="field__input"
                  placeholder="jane@example.com" value={form.email} onChange={change} required disabled={loading} />
              </div>
            </div>
            <div className="field">
              <label className="field__label" htmlFor="c-subject">Subject</label>
              <select id="c-subject" name="subject" className="field__input field__select"
                value={form.subject} onChange={change} required disabled={loading}>
                <option value="">Select a topic</option>
                <option value="general">General Inquiry</option>
                <option value="bug">Bug Report</option>
                <option value="download">Download Issue</option>
                <option value="account">Account Problem</option>
                <option value="copyright">Copyright Concern</option>
                <option value="other">Other</option>
              </select>
            </div>
            <div className="field">
              <label className="field__label" htmlFor="c-message">Message</label>
              <textarea id="c-message" name="message" className="field__input field__textarea"
                placeholder="Describe your question or issue in detail..."
                value={form.message} onChange={change} required disabled={loading} rows={5} />
            </div>
            <button type="submit" className="btn-primary btn-full" disabled={loading}>
              {loading ? <span className="spinner" /> : "Send Message"}
            </button>
          </form>
        </div>
      </div>
    </div>
  );
};

export default Contact;
